module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-violet-9695638610b58f1d1d01b268a1340cf1.png";